import { useContext } from 'react';
import {
  HomeContext,
  CategoryContext,
  ArticleContext,
  ArticleFragmentContext,
} from '../contexts';
import { IArticleFragment } from '../types';

export default function useArticleFragment(
  articleId?: string
): IArticleFragment | undefined {
  const fragment = useContext(ArticleFragmentContext);
  const article = useContext(ArticleContext);
  const category = useContext(CategoryContext);
  const home = useContext(HomeContext);

  if (!articleId) {
    if (fragment) return fragment;
    if (article) {
      return {
        id: article.id,
        title: article.title,
        slug: article.slug,
        summary: article.summary,
        categoryId: article.category.id,
      };
    }
    return undefined;
  }

  if (fragment && fragment.id === articleId) return fragment;

  if (article && article.id === articleId)
    return {
      id: article.id,
      title: article.title,
      slug: article.slug,
      summary: article.summary,
      categoryId: article.category.id,
    };

  if (category) {
    const _article = category.articles.results.find(a => a.id === articleId);
    if (_article) {
      return {
        id: _article.id,
        title: _article.title,
        slug: _article.slug,
        summary: _article.summary,
        categoryId: category.id,
      };
    }
  }

  if (home && home.categories) {
    const categories = home.categories;
    let _article;
    for (const cat of categories) {
      _article = cat.articles.results.find(a => a.id === articleId);
      if (_article) {
        return {
          id: _article.id,
          title: _article.title,
          slug: _article.slug,
          summary: _article.summary,
          categoryId: cat.id,
        };
      }
    }
  }

  return undefined;
}
